import { HTTP_TOKEN } from "./http";

export const createExportData = (params) => {
  return HTTP_TOKEN.post("export", params).then((result) => {
    return result.data;
  });
};
